export default __webpack_public_path__ + "static/media/Samuele Olindo.fd0f823f.jpg";